module.exports = __webpack_public_path__ + "static/media/SN.538a5430.png";